import axios from "axios";
import { apiRoot } from "../config/runtime";

axios.defaults.baseURL = apiRoot;

export default axios;
